// Utilities
import { createSentryPiniaPlugin } from "@sentry/vue";
import { createPinia } from "pinia";

const pinia = createPinia();
pinia.use(createSentryPiniaPlugin());

export default pinia;
